module.exports = __webpack_public_path__ + "img/mgs.f4aa2189.svg";